import styled from 'styled-components';

export const Wrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 10; /* Ensure it stays above other content */
  background-color: var(--mantine-color-body);
  height: 60px;
  overflow: hidden;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Bars = styled.div`
  transition: all 0.3s;

  &.index-0 {
    transform: translateY(0);
  }

  &.index-1 {
    transform: translateY(-60px);
  }
`;

export const Bar = styled.div`
  height: 60px;
`;
